import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { Interaction } from 'src/app/modules/entities/interaction';
import { Person } from 'src/app/modules/entities/person';
import { InteractionService } from 'src/app/modules/services/interaction.service';
import { PersonService } from 'src/app/modules/services/person.service';
import { registerLocaleData } from '@angular/common';
import localeCo from '@angular/common/locales/es-CO';
import { SelectButtonChangeEvent } from 'primeng/selectbutton';
import { url } from 'src/app/modules/util/constants';
registerLocaleData(localeCo, 'co');

@Component({
  selector: 'app-profile-details',
  templateUrl: './profile-details.component.html',
  styleUrls: ['./profile-details.component.css']
})
export class ProfileDetailsComponent implements OnInit {

  constructor(private router: Router, private route: ActivatedRoute, private personService: PersonService, 
    private interactionService: InteractionService, private cookies: CookieService) { 
    this.urlId = this.route.snapshot.paramMap.get('id');
  }

  urlId: string | null;
  person: Person | undefined = undefined;
  interactions: Interaction[] | undefined = undefined;
  interactionsByType: { [key: string]: Interaction[] } = { 'profile_view': [], 'phone': [], 'whatsapp': [] };
  interactionTypes: string[] = ['profile_view', 'whatsapp', 'phone'];
  interactionOptions: { [key: string]: { [key: string]: string } } = 
  { 'profile_view': {'label': 'Visitas al perfil', 'textColor': 'var(--text-color-secondary, Black)', 'rangeColor': 'var(--surface-border, LightGray)', 'valueColor': '#ed1c23', 'first': 'Primera visita', 'last': 'Última visita'},
    'phone': {'label': 'Intentos de llamada', 'textColor': 'var(--text-color-secondary, Black)', 'rangeColor': 'var(--surface-border, LightGray)', 'valueColor': '#003ea1', 'first': 'Primer intento', 'last': 'Último intento'},
    'whatsapp': {'label': 'Intentos de contacto en WhatsApp', 'textColor': 'var(--text-color-secondary, Black)', 'rangeColor': 'var(--surface-border, LightGray)', 'valueColor': '#25d366', 'first': 'Primer intento', 'last': 'Último intento'}
  };
  numberOfInteractions: { [key: string]: number } = { 'profile_view': 0, 'phone': 0, 'whatsapp': 0};
  timePeriods: object[] = [{ name: 'Todo', value: -1 }, { name: '1 mes', value: 30 }, { name: '1 semana', value: 7 }];
  selectedPeriod: number = -1;

  ngOnInit(): void {
    if (this.urlId) {
      this.personService.getFullProfile(this.urlId, 0).subscribe(response => {
        this.person = response.data as Person;
      });
      this.interactionService.getAllInteractionsByPerson(this.urlId).subscribe(response => {
        this.interactions = response.data as Interaction[];
        for (let interaction of this.interactions) {
          this.interactionsByType[interaction.type].push(interaction);
        }
        for (let type of this.interactionTypes) {
          this.numberOfInteractions[type] = this.interactionsByType[type].length;
        }
      });
    }
  }

  changePeriod(event: SelectButtonChangeEvent): void {
    if (event.value === -1) {
      for (let type of this.interactionTypes) {
        this.numberOfInteractions[type] = this.interactionsByType[type].length;
      }
    } else if (event.value > 0) {
      for (let type of this.interactionTypes) {
        let filtered = this.interactionsByType[type].filter(x => Date.parse(x.interactionDate!.toString()) >= Date.now() - (event.value * 24 * 60 * 60 * 1000));
        this.numberOfInteractions[type] = filtered.length;
      }
    }
  }

  goToProfile() {
    this.router.navigate([url['perfil'] + '/' + this.urlId]);
  }

}
